import Swal from 'sweetalert2';

const Toast = Swal.mixin({
  // toast: true,
  position: 'center',
  showConfirmButton: false,
  timer: 3000,
  // timerProgressBar: true,
  // didOpen: (toast) => {
  //   toast.addEventListener('mouseenter', Swal.stopTimer)
  //   toast.addEventListener('mouseleave', Swal.resumeTimer)
  // }
})


export const useShowMessages = () => {

    const getSwalTheme = () => {
      const isDark = localStorage.getItem('theme') === 'dark';
      return isDark
        ? {
            background: '#1f1f1f',
            color: '#f1f1f1',
            customClass: { popup: 'swal2-dark-popup' },
          }
        : {};
    };

    const ShowMessage = (type, title, msg, time = 3) => {
      if(type === 'warning'){
        return  Swal.fire({
                  ...getSwalTheme(),
                  icon: type,
                  title: title,
                  text: msg,
                  showConfirmButton: true,
                  confirmButtonColor: '#3085d6',
                  confirmButtonText: 'Confirmar',
                })
      } else {
        return  Toast.fire({
                  ...getSwalTheme(),
                  icon: type,
                  title: title,
                  text: msg,
                  timer: time*1000
                })
      }

    }

    const showPopup = (type, title) => {
      Swal.fire({
        ...getSwalTheme(),
        position: 'center',
        icon: type,
        title: title,
        showConfirmButton: false,
        timer: 1500
      });
    }

    // Retorna uma promise com a escolha do usuário (true = confirmou), para quem
    // precisa aguardar a resposta em vez de usar o callback.
    const msgConfirm = (title, msg, btnConfirm, btnCancel, callback, icon = 'question') => {
      return Swal.fire({
        ...getSwalTheme(),
        title: title,
        text: msg,
        icon: icon,
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: btnConfirm,
        cancelButtonText: btnCancel
      }).then((result) => {
        if (result.isConfirmed) {
          if (callback) callback();
          return true;
        }
        return false;
      })

    }

    const msgPassword = async (title, msg, btnConfirm, btnCancel, user, verifyPassword, callback) => {

      let realPassword = "";
    
      return Swal.fire({
        ...getSwalTheme(),
        title: title,
        text: msg,
        // O estilo do campo vive no index.css (#passwordInput), junto das variações de tema
        // escuro, para não repetir cores aqui dentro do html.
        html: `
          <form id="passwordForm">
            <p >${msg}</p>
            <br>
            <input id="passwordInput" type="text" placeholder="Insira sua senha" autocomplete="off" />
          </form>
        `,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: btnConfirm,
        cancelButtonText: btnCancel,
        didOpen: () => {
          const input = document.getElementById("passwordInput");
          input.addEventListener("input", (e) => {
            if (e.inputType === "deleteContentBackward") {
              const { selectionStart, selectionEnd } = input;
              if (selectionStart === 0 && selectionEnd === 0) {
                realPassword = "";
              } else {
                realPassword = realPassword.slice(0, -1);
              }
            } else {
              realPassword += e.data || ""; 
            }
            input.value = " * ".repeat(realPassword.length);
          });
        },
        preConfirm: async () => {
          if (!realPassword) {
            Swal.showValidationMessage("Insira sua senha para continuar");
          } else {
            await verifyPassword(user, realPassword).then((res) => {
                if (!res.Authenticated) {
                  Swal.showValidationMessage(res.msg);
                } else {
                  return realPassword; 
                }
              }         
            )
          }
          
        }
      }).then((result) => {
        if (result.isConfirmed) {
          showPopup('success', 'Liberação efetuada com sucesso');
          if (callback) callback();
          return true;
        }
        showPopup('error', 'Liberação cancelada');
        return false;
      });
    };
    
    
    

    return{ ShowMessage, msgConfirm, msgPassword }
}
